import { Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'src/app/core/services/storage.service';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/core/services/common.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.css']
})
export class ReviewComponent implements OnInit {
  public assessmentForm!: FormGroup;
  assessment!: any;
  quesLanguage!: string;
  navParam!: string;
  contactId!: string;
  questionnaireList: any;
  isArabic!: boolean;
  modalRefDeactivate!: BsModalRef;
  questionnaireEvent = new EventEmitter();
  constructor(private activateRoute: ActivatedRoute, private route: Router, private storageService: StorageService,
    private assessmentService: AssessmentService, public formBuilder: FormBuilder, private commonService: CommonService,
    private modalService: BsModalService) { }

  ngOnInit(): void {
    this.assessmentForm = this.formBuilder.group({
      questionnaire: ['', [Validators.required]]
    });
    let userData = this.storageService.getSessionStorageData('userDetails');
    //console.log('sessionData in assessment: ', userData);
    this.isArabic = this.storageService.getSessionStorageData('isArabic');

    const rqstBody = { assessmentUnit: userData?.assessmentUnitValue, contactguid: userData?.contactguid };
    this.assessmentService.fetchReviewQuestionnaireList(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      //console.log('get questionnaire list in assessment: ', decryptedData);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      this.questionnaireList = resp.questionnaires;
      //console.log('list of review questionnaires: ', this.questionnaireList);
      let selectedQuestionnaire;
      if (this.questionnaireList.length > 0) {
        selectedQuestionnaire = this.questionnaireList[0];
        this.assessmentForm.controls['questionnaire'].setValue(this.questionnaireList[0].questionnaireId);
        this.assessment = JSON.stringify(this.questionnaireList[0]);
        // console.log("fetchSubmittedQuestionnaires setting asessment")
        this.questionnaireEvent.emit(this.assessment);
      }
    }, (error: any) => {
      //console.log(error);
      if (error?.body?.error == 'The Assossicated Assessment Entity has deactivated') {
        this.showDeactivationPopup();
      }
    });
  }

  showDeactivationPopup() {
    let pathUrl = 'login';
    let message = '';
    if (this.isArabic) {
      message = '.تم إلغاء تنشيط كيان الاتصال / التقييم';
    } else {
      message = 'Contact/Assessment Entity has been deactivated.';
    }
    const initialState = {
      message: message,
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRefDeactivate = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }


  selectQuestionnaire(evt: any) {
    let selectedAssessmentId = evt.target?.value;
    if (selectedAssessmentId !== '') {
      let selectedAssessment = this.questionnaireList.filter((ele: any) => ele?.questionnaireId == selectedAssessmentId);
      if (selectedAssessment.length > 0) {
        this.assessment = JSON.stringify(selectedAssessment[0]);
        this.questionnaireEvent.emit(this.assessment);
      }
    } else {
      this.questionnaireEvent.emit(null);
    }
    //console.log('in asessment: ', this.assessment);

  }

}
